import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {LoginInput} from '../shared/domain/user.type';
import {catchError, map, Observable, tap, throwError} from 'rxjs';
import {UsersRepository} from '../shared/api/users.repository';
import {PermissionService} from './permission.service';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  #localStorage = inject(LocalStorageService);
  private _isAuthenticated: WritableSignal<boolean> = signal(false);
  #usersRepository: UsersRepository = inject(UsersRepository);
  #permissionService = inject(PermissionService);

  login$(loginInput: LoginInput): Observable<any> {
    return this.#usersRepository.login$(loginInput)
      .pipe(
        catchError((err) => throwError(() => err?.error?.message ?? err)),
        tap((token) => {
          if (token?.token) {
            this.#localStorage.setItem('token', token.token);
            this._isAuthenticated.set(true);
          }
        }),
        map(() => void 0)
      );
  }

  logout$() {
    this._isAuthenticated.set(false);
    this.#permissionService.clearPermissions();
    this.#usersRepository.logout$();
  }

  isAuthenticatedUser(): boolean {
    const isAuthenticated = !!this.#localStorage.getItem("token");
    this._isAuthenticated.set(isAuthenticated);

    if (!isAuthenticated) {
      this.#permissionService.clearPermissions();
    }

    return isAuthenticated;
  }
}
